export default __webpack_public_path__ + "static/media/amartya.86f720fa.svg";